import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import Modal from '@bd/bdui-modal';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';

import { grid, colors } from '../styles';
import icons from './IconsList';
import Form from './Forms/Form';

const modalStyles = css`
  width: 95%;
  max-width: 535px;
  margin: 5vh auto 10vh;
  .ModalBody_wrapper {
    .ModalContent_wrapper {
      ${grid.makeRow()};
      margin: 0;
      height: auto;
      min-height: 95px;
      @media(min-width: 576px) {
        height: 125px;
      }
      @media(min-width: 768px) {
        height: 205px;
      }
    }
  }
  .ContactModal_logoImage {
    width: 160px;
    height: 100px;
  }
  .ContactModal_form {
    background-color: ${colors.color3};
    padding: 20px 15px 70px;
    @media(min-width: 576px) {
      padding: 20px 40px 70px 40px;
    }
  }
  .ModalHeader_wrapper {
    height: 93px;
    background-color: ${colors.color2};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 0 30px;
  }
  .ContactModal_close {
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 30px;
    .ContactModal_closeBtn {
      font-weight: 800;
      font-size: 15px;
      color: #29231B;
      letter-spacing: 2.81px;
      text-transform: uppercase;
      cursor: pointer;
      position: relative;
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0 25px;
      &::after, &::before {
        position: absolute;
        right: 5px;
        top: 18px;
        content: ' ';
        height: 33px;
        width: 2px;
        background-color: #FFFFFF;
      }
      &:before {
        transform: rotate(45deg);
      }
      &:after {
        transform: rotate(-45deg);
      }
      &:focus {
        outline: none;
      }
    }
  }
  .ModalTitle {
    font-weight: 700;
    font-size: 25px;
    color: #FFFFFF;
    letter-spacing: 1.56px;
    @media(min-width: 992px) {
      font-size: 29px;
      letter-spacing: 1.81px;
    }
  }
  .ModalSubtitle {
    font-weight: 800;
    font-size: 15px;
    color: #FFFFFF;
    letter-spacing: 3.33px;
    text-transform: uppercase;
    @media(min-width: 992px) {
      font-size: 18px;
      letter-spacing: 4px;
    }
  }

  label {
    color: #FFFFFF;
  }

  .Form_success {
    color: #FFFFFF !important;

    div, p, b {
    color: #FFFFFF !important;
    }
  }
`;

const modalOverlayStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  background-color: rgba(0,0,0, 0.85);
  overflow-y: auto;
`;

// const formStyles = css``;

class ContactModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(e) {
    let currentElem = e.target;

    while (currentElem.tagName !== 'A' && currentElem.parentNode !== document) {
      currentElem = currentElem.parentNode;
    }

    if (currentElem.nodeName !== 'A') {
      e.preventDefault();
      this.setState({
        modalIsOpen: true,
      });
    }
  }

  closeModal(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ modalIsOpen: false });
  }

  render() {
    const { children, widget } = this.props;
    return (
      <div className="ContactModal_wrapper">
        <span role="button" tabIndex={0} onClick={this.openModal} className="ContactModal_btn">
          {children}
        </span>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Contact Modal"
          className={modalStyles}
          overlayClassName={modalOverlayStyles}
        >
          <div className="ModalBody_wrapper">
            <div className="ModalHeader_wrapper">
              <Link name="index">
                <img src={get(icons, 'logo')} alt="Taber Logo" className="ContactModal_logoImage" />
              </Link>
              <div className="ContactModal_close">
                <span onClick={this.closeModal} role="button" tabIndex={0} className="ContactModal_closeBtn" />
              </div>
            </div>
            <div className="ContactModal_form">
              <div className="container">
                <div className="row">
                  <div className="col-12 mb-3 mb-lg-4 mb-5">
                    <h3 className="ModalTitle">{get(widget, 'title')}</h3>
                    <h4 className="ModalSubtitle">{get(widget, 'subtitle')}</h4>
                  </div>
                  <div className="col-12">
                    <Form
                      formName="contactUsModal"
                      formLabel="Contact Us Modal"
                      fields={[
                        {
                          type: 'Text',
                          label: 'First Name',
                          className: 'form-col',
                          field: 'firstName',
                          required: true,
                        },
                        {
                          type: 'Text',
                          label: 'Last Name',
                          className: 'form-col',
                          field: 'lastName',
                          required: true,
                        },
                        {
                          type: 'Email',
                          label: 'Email',
                          className: 'form-col',
                          field: 'email',
                          required: true,
                          requiredMessage: '',
                          invalidMessage: '',
                        },
                        {
                          type: 'Phone',
                          label: 'Phone',
                          className: 'form-col',
                          field: 'phone',
                          required: true,
                          requiredMessage: '',
                          invalidMessage: '',
                        },
                        {
                          type: 'TextArea',
                          label: 'Comments/Questions',
                          className: 'form-col-fluid',
                          placeholder: 'How can we help you?',
                          field: 'comments',
                          required: false,
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

ContactModal.propTypes = {
  children: PropTypes.node.isRequired,
  widget: PropTypes.object.isRequired,
};

export default withData({
  widget: 'contact_modal',
})(ContactModal);



// WEBPACK FOOTER //
// ./src/components/ContactModal.js